<div class="input-group input-group-merge form-password-toggle">
    <input
            [type]="passwordTextType ? 'text' : 'password'"
            [ngModel]="value"
            (ngModelChange)="onModelChange($event)"
            [disabled]="isDisabled"
            (touchend)="onControlTouched($event)"
            class="form-control form-control-merge"
            placeholder="············"
            aria-describedby="register-password"
            #passwordInput
    />

    <!--[ngClass]="{ 'is-invalid error': submitted && form.password.errors }"-->

    <div class="input-group-append">
                            <span class="input-group-text cursor-pointer">
                                <i
                                        class="feather font-small-4"
                                        [ngClass]="{
                                    'icon-eye-off': passwordTextType,
                                    'icon-eye': !passwordTextType
                                    }"
                                        (click)="togglePasswordTextType()"
                                ></i>
                            </span>
    </div>
</div>